import React, { FC, FormEvent } from 'react';
import { LoadTableStops } from '../table-components/stops/load-table-stops';
import { useAddLoadMutation } from '../../../api/mutations/reworked/add/use-add-load-mutation';
import { useDraftLoadContext } from '../hooks/draft-load-context';
import { useEditLoadMutation } from '../../../api/mutations/reworked/edit/use-edit-load-mutation';
import { L } from 'harmony-language';
import { Button } from '@mui/material';
import Save from '@mui/icons-material/Save';
import { EditCreateLoadTop } from './edit-create-load-top';
import { EditableLoadFormula } from '../drafts-loads-table-cells/loads/editable/editable-load-formula';
import { useDraftsLoadsContext } from '../drafts-loads-context';

interface EditCreateLoadFormProps {
    onSubmit: () => void;
    // if onBack we are in isCreateSingleDraft mode, doing it this way to get styles right for button/dropdown
    onBack?: () => void;
}

export const EditCreateLoadForm: FC<EditCreateLoadFormProps> = (props) => {
    const { onSubmit, onBack } = props;
    const { isDrafts } = useDraftsLoadsContext();
    const { editedLoad } = useDraftLoadContext();
    const { mutate: addLoad } = useAddLoadMutation(isDrafts);
    const { mutate: editLoad } = useEditLoadMutation(isDrafts);

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        // ignore typescript here until we get a typescript concept for Create/Edit Load
        if ('id' in editedLoad) {
            editLoad({ load: editedLoad });
        } else {
            addLoad({ load: editedLoad });
        }

        onSubmit();
    };

    return (
        <form
            onSubmit={handleSubmit}
            style={{ fontSize: '.875rem' }}
        >
            {onBack ?
                <EditableLoadFormula onBack={onBack} />
            :
                <EditCreateLoadTop
                    editedLoad={editedLoad}
                />
            }
            <LoadTableStops />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    startIcon={<Save />}
                    type='submit'
                    color='primary'
                    variant='contained'
                >
                    {L.save()}
                </Button>
            </div>
        </form>
    );
};
